
  <h2 translate>WEEK.CHART_TITLE</h2>
  <div class="graph-container">
    <canvas class="chart-canvas" #chartCanvas></canvas>

    <ng-template [ngIf]="loadingData">
      <div class="graph-spinner-container">
        <ion-spinner color="dark"></ion-spinner>
      </div>
    </ng-template>

  </div>

